{
  "familyId": "TOPO-WERELD-KLIMAAT",
  "questions": [
    {
      "id": "TOPO-WERELD-KLIMAAT-001",
      "familyId": "TOPO-WERELD-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_klimaat_wereld",
      "questionType": "multiple_choice",
      "question": "Welke klimaatzone vind je rond de evenaar?",
      "options": [
        "Tropisch klimaat",
        "Gematigd klimaat",
        "Poolklimaat",
        "Woestijnklimaat"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Klimaatzones wereld",
            "content": "Rond de evenaar is het tropisch: warm en vochtig het hele jaar. De zon staat daar het hoogst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_klimaat_tropisch",
      "variantIndex": 1,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Rond de evenaar is het tropisch klimaat: warm en vochtig het hele jaar door. De zon staat daar bijna recht boven je hoofd.",
        "solutionSteps": [
          "Evenaar = meeste zonlicht",
          "Warm + vochtig = tropisch klimaat"
        ],
        "distractorExplanations": {
          "0": "Goed! Rond de evenaar is het tropisch.",
          "1": "Gematigd klimaat vind je in de middengebieden (zoals Nederland). Rond de evenaar is het veel warmer. Onthoud: evenaar = tropisch.",
          "2": "Poolklimaat vind je bij de Noord- en Zuidpool. Dat is het tegenovergestelde van de evenaar. Onthoud: pool = koud, evenaar = warm.",
          "3": "Woestijnklimaat is droog, maar niet altijd tropisch. Rond de evenaar is het juist vochtig. Onthoud: tropisch = warm + vochtig."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-001-OPT1",
            "optionIndex": 1,
            "label": "Rond de evenaar is het veel warmer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-001-OPT2",
            "optionIndex": 2,
            "label": "Dat is het tegenovergestelde van de evenaar"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-001-OPT3",
            "optionIndex": 3,
            "label": "Rond de evenaar is het juist vochtig"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_klimaat_wereld"
          }
        }
      ]
    },
    {
      "id": "TOPO-WERELD-KLIMAAT-002",
      "familyId": "TOPO-WERELD-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_klimaat_wereld",
      "questionType": "multiple_choice",
      "question": "De Sahara heeft een woestijnklimaat. Wat is daar typisch?",
      "options": [
        "Zeer droog en grote temperatuurverschillen",
        "Warm en vochtig het hele jaar",
        "Koude winters en warme zomers",
        "Veel regen in de herfst"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Woestijnklimaat",
            "content": "Woestijnklimaat = zeer weinig regen (<250 mm/jaar) en grote temperatuurverschillen tussen dag en nacht.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_klimaat_woestijn",
      "variantIndex": 2,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De Sahara heeft een woestijnklimaat: zeer droog (bijna geen regen) en grote temperatuurverschillen. Overdag kan het 50°C zijn, 's nachts kan het afkoelen tot onder 0°C.",
        "solutionSteps": [
          "Woestijn = zeer weinig regen",
          "Grote temperatuurverschillen dag/nacht"
        ],
        "distractorExplanations": {
          "0": "Goed! Woestijn = droog + grote temperatuurverschillen.",
          "1": "Warm en vochtig is tropisch klimaat (regenwoud). De Sahara is juist extreem droog. Onthoud: woestijn = droog.",
          "2": "Koude winters en warme zomers is continentaal klimaat. De Sahara heeft geen echte winter. Onthoud: woestijn ≠ continentaal.",
          "3": "In de Sahara regent het bijna nooit. Veel regen past bij een zeeklimaat of tropisch klimaat."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-002-OPT1",
            "optionIndex": 1,
            "label": "De Sahara is juist extreem droog"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-002-OPT2",
            "optionIndex": 2,
            "label": "De Sahara heeft geen echte winter"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-002-OPT3",
            "optionIndex": 3,
            "label": "In de Sahara regent het bijna nooit"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_klimaat_wereld"
          }
        }
      ]
    },
    {
      "id": "TOPO-WERELD-KLIMAAT-003",
      "familyId": "TOPO-WERELD-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_klimaat_wereld",
      "questionType": "multiple_choice",
      "question": "Waarom is het bij de polen zo koud?",
      "options": [
        "De zonnestralen vallen schuin, waardoor ze minder warmte geven",
        "Er is geen lucht bij de polen",
        "De aarde draait daar langzamer",
        "De polen liggen het verst van de zon"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zonnestralen en hoek",
            "content": "Bij de polen vallen de zonnestralen schuin op de aarde. Daardoor verspreiden ze over een groter oppervlak en geven minder warmte per m².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_klimaat_polen",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij de polen vallen de zonnestralen schuin op de aarde. Schuine stralen verspreiden over een groter oppervlak, waardoor er minder warmte per vierkante meter is.",
        "solutionSteps": [
          "Schuine zonnestralen = minder warmte per m²",
          "Evenaar: recht → veel warmte",
          "Polen: schuin → weinig warmte"
        ],
        "distractorExplanations": {
          "0": "Goed! Schuine zonnestralen geven minder warmte.",
          "1": "Er is wel lucht bij de polen. De atmosfeer bedekt de hele aarde. Onthoud: de hoek van de zonnestralen is de reden.",
          "2": "De aarde draait overal even snel. De rotatiesnelheid heeft niets te maken met de temperatuur bij de polen.",
          "3": "De polen liggen niet verder van de zon. Het verschil in afstand is verwaarloosbaar. De hoek van de zonnestralen is de echte reden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-003-OPT1",
            "optionIndex": 1,
            "label": "Er is wel lucht bij de polen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-003-OPT2",
            "optionIndex": 2,
            "label": "De aarde draait overal even snel"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-003-OPT3",
            "optionIndex": 3,
            "label": "De polen liggen niet verder van de zon"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_klimaat_wereld"
          }
        }
      ]
    },
    {
      "id": "TOPO-WERELD-KLIMAAT-004",
      "familyId": "TOPO-WERELD-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_klimaat_wereld",
      "questionType": "multiple_choice",
      "question": "In welke klimaatzone ligt het Amazone-regenwoud?",
      "options": [
        "Tropisch klimaat",
        "Gematigd klimaat",
        "Subtropisch klimaat",
        "Continentaal klimaat"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Amazone",
            "content": "Het Amazone-regenwoud ligt rond de evenaar in Zuid-Amerika. Daar is het tropisch: warm, vochtig, veel regen het hele jaar.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_klimaat_amazone",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Het Amazone-regenwoud ligt rond de evenaar. Daar is het tropisch klimaat: warm (25-30°C), vochtig, en veel regen het hele jaar door.",
        "solutionSteps": [
          "Amazone = rond de evenaar",
          "Evenaar = tropisch klimaat",
          "Warm + vochtig + veel regen"
        ],
        "distractorExplanations": {
          "0": "Goed! Het Amazone-regenwoud heeft een tropisch klimaat.",
          "1": "Gematigd klimaat is te koel voor een regenwoud. Dat past bij Europa. Onthoud: regenwoud = tropisch.",
          "2": "Subtropisch is iets koeler dan tropisch en heeft drogere periodes. Het Amazone-regenwoud is echt tropisch. Onthoud: Amazone = evenaar = tropisch.",
          "3": "Continentaal klimaat heeft koude winters. Het Amazone-regenwoud kent geen winter. Onthoud: tropisch = geen seizoenen."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-004-OPT1",
            "optionIndex": 1,
            "label": "Dat past bij Europa"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-004-OPT2",
            "optionIndex": 2,
            "label": "Het Amazone-regenwoud is echt tropisch"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-KLIMAAT-004-OPT3",
            "optionIndex": 3,
            "label": "Continentaal klimaat heeft koude winters"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_klimaat_wereld"
          }
        }
      ]
    },
    {
      "id": "TOPO-WERELD-KLIMAAT-005",
      "familyId": "TOPO-WERELD-KLIMAAT",
      "module": "Topo",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_klimaat_wereld",
      "questionType": "matching",
      "question": "Koppel elke klimaatzone aan het juiste kenmerk.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": [
          "Tropisch",
          "Woestijn",
          "Gematigd",
          "Pool"
        ],
        "rightItems": [
          "zeer koud, ijs en sneeuw",
          "warm en vochtig, veel regen",
          "mild, wisselende seizoenen",
          "zeer droog, grote temperatuurverschillen"
        ],
        "correctMatches": {
          "0": 1,
          "1": 3,
          "2": 2,
          "3": 0
        }
      },
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Klimaatzones",
            "content": "Tropisch = warm+vochtig. Woestijn = droog+extremen. Gematigd = mild+seizoenen. Pool = koud+ijs.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_klimaat_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Tropisch = warm en vochtig. Woestijn = zeer droog. Gematigd = mild met seizoenen. Pool = zeer koud met ijs.",
        "solutionSteps": [
          "Tropisch → warm + vochtig",
          "Woestijn → droog + extremen",
          "Gematigd → mild + seizoenen",
          "Pool → koud + ijs"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_klimaat_wereld"
          }
        }
      ]
    }
  ]
}